module.exports = "/_next/static/images/90a86b75da88080c2aa7b1bb556b1d97-nubanker-tpm@2x.jpg.webp";